'use strict';
import React from 'react';
import { TweenMax, TimelineMax, EasePack} from 'gsap';
import TextPlugin from 'gsap/TextPlugin';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import settings from '../../util/settings';
import Button from '../../components/Button/Button';
import ReactGA from 'react-ga';
import Plx from 'react-plx';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.AnimationElements = []
    this.ASSET_PATH = settings.ASSET_PATH + "images/";
  }
  componentDidMount() {
    TweenMax.set(this.container, {autoAlpha: 0});
    TweenMax.set(this.AnimationElements, {autoAlpha: 0});

    this.props.refSetter(this.container, this.props.refOrder)
    this.animateIn();
  }
  componentWillUnmount() {
  }
  componentDidUpdate() {
  }
  animateIn = () => {
    var tl = new TimelineMax({paused: true, delay: 0.5});
    tl.to(this.container, 1, {autoAlpha: 1});
    tl.staggerFromTo(this.AnimationElements, 2, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Expo.easeOut}, 0.25);
    tl.play();
  }

  insertDot = hideOnSmall => {
    return <span className={`dot ${hideOnSmall ? 'hide' : ''}`}>●</span>
  }

  render() {
    this.AnimationElements = []
    return <div
      id="section-home"
      ref={el => this.container = el}
      style={{opacity: 0}}
    >
      <div id="landing-gradient" />
      <Plx  className='intro-content'
            parallaxData={[{
             start: 0,
             duration: 500,
             properties: [
               {
                 startValue: 0,
                 endValue: -100,
                 property: "translateY"
               }
             ]
           }]}>
        <div className="intro-content">
          <h2>SINGLE SOURCE SUPPLIER</h2>
          <h4>METAL SALES {this.insertDot()} CUT TO SIZE {this.insertDot(true)} NO MINIMUM ORDER</h4>
          <div className="buttons-container row">
            <Button title="(905)  660 - 3386" icon="phone" mirrored link="tel:+19056603386"/>
            <div className="divider" style={{ opacity: 0.3 }} />
            <Button title="EMAIL" icon="envelope" action={this.props.scrollTo.bind(this, "contact")}/>
          </div>
        </div>
      </Plx>

      { /* Scroll Down SVG */ }
      <Plx className='scroll-icon'
           parallaxData={[{
             start: 0,
             duration: 150,
             properties: [
               {
                 startValue: 1,
                 endValue: 0,
                 property: "opacity"
               },
               {
                 startValue: 0,
                 endValue: -50,
                 property: "translateY"
               }
             ]
           }]}>
        <svg viewBox="0 0 247 390" onClick={this.props.scrollTo.bind(this, "products")} ref={el => this.AnimationElements[0] = el}>
          <path id="wheel" d="M123.359,180 L123.359,250"/>
          <path id="mouse" d="M236.717,123.359c0,-62.565 -50.794,-113.359 -113.358,-113.359c-62.565,0 -113.359,50.794 -113.359,113.359l0,143.237c0,62.565 50.794,113.359 113.359,113.359c62.564,0 113.358,-50.794 113.358,-113.359l0,-143.237Z"/>
        </svg>
      </Plx>
    </div>;
  }
};

Home.defaultProps = {
  windowWidth: 960,
  windowHeight: 570
};

export default Home;



// WEBPACK FOOTER //
// ./sections/Home/Home.js